import { createContext } from 'react';

const UserDatas = createContext();

export default UserDatas;

/* const { userDatas, setUserDatas } = useContext(); */